import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { applyActionCode, checkActionCode } from "firebase/auth";
import { auth } from "../../firebase";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying your email...");
  const navigate = useNavigate();

  useEffect(() => {
    const oobCode = searchParams.get("oobCode");
    if (!oobCode) {
      setStatus("❌ Invalid verification link.");
      return;
    }

    const verifyEmail = async () => {
      try {
        // Step 1: Get the email from the oobCode
        const actionInfo = await checkActionCode(auth, oobCode);
        const email = actionInfo.data.email;

        // Step 2: Apply the action code (verify)
        await applyActionCode(auth, oobCode);
        setStatus("✅ Your email has been verified!");

        // Step 3: Sync Firestore
        const res = await fetch(`${BACKEND_URL}/auth/verify-email?email=${encodeURIComponent(email)}`);
        const data = await res.json();

        if (!res.ok) {
          console.warn("⚠️ Firestore sync failed:", data.message);
        } else {
          console.log("✅ Firestore synced:", data.message);
        }

        setTimeout(() => navigate("/login"), 3000);
      } catch (err) {
        console.error("❌ Verification failed:", err);
        setStatus("❌ Invalid or expired verification link.");
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: "80px", textAlign: "center" }}>
      <h2>{status}</h2>
      <p>You will be redirected shortly...</p>
    </div>
  );
};

export default VerifyEmailPage;
